export default __webpack_public_path__ + "static/media/img_autopass_en.df857f1a.svg";